<template>
  <div class="main-content">
    <div class="card">
      <h5 class="card-header d-flex justify-content-between align-items-center">
        <div class="flex-grow-1">Сегменты клиентов (для обзвона и рассылок)</div>
        <vue-ladda
          button-class="btn btn-sm btn-info"
          data-style="zoom-in"
          @click="addItem()"
          :loading="loadingAdd"
        ><i class="icon-fa icon-fa-plus"></i>Добавить сегмент</vue-ladda>
      </h5>
      <div class="card-body">
        <pulse-loader
          :loading="loading"
          :color="'#007dcc'"
          style="text-align: center"
        />
        <sweet-modal
          ref="showSmsModal"
          width="90%"
          overlay-theme="dark"
        >
          <div class="text-left">
            <h5 v-if="currentItem">{{ currentItem.title }} [ID: {{ currentItem.id }}]</h5>
            <div class="sms-table">
              <div v-for="smsItem in smsItems" :class="{'sms-item': true, 'sms-error': smsItem.status === '0'}">
                <div class="sms-val" style="min-width: 180px;"><i class="icon-fa icon-fa-phone"></i> {{ smsItem.phone_number }}</div>
                <div class="sms-val" style="min-width: 200px;font-size: 14px;"><i class="icon-fa icon-fa-user"></i> {{ smsItem.order.fio }}</div>
                <div class="sms-val sms-body">{{ smsItem.sms_body }}</div>
                <div class="sms-val">
                  <span v-if="smsItem.status !== '0'">Успешно</span>
                  <div v-else>
                    <span>Ошибка оптравки</span><br>
                    <div class="send-error" v-if="smsItem.system_info">{{ smsItem.system_info }}</div>
                    <button @click="sendSms(currentItem, true, {'resend': smsItem})" :disabled="loadingSend" class="btn btn-sm btn-success"
                            type="button">
                      <i class="icon-fa icon-fa-send"></i> Отправить повторно
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </sweet-modal>
        <sweet-modal
          ref="showClientsModal"
          width="90%"
          overlay-theme="dark"
        >
          <div class="text-left">
            <h5 v-if="currentItem">
              {{ currentItem.title }} [ID: {{ currentItem.id }}]
              <span v-if="currentItem.includeFrom || currentItem.includeTo" class="include-label">
                  &nbsp;<i class="icon-fa icon-fa-plus"></i>
                  {{ currentItem.includeFrom || '...' }}&nbsp;—&nbsp;{{ currentItem.includeTo || '...' }}
              </span>
              <span v-if="currentItem.excludeFrom || currentItem.excludeTo" class="exclude-label">
                  &nbsp;<i class="icon-fa icon-fa-minus"></i>
                  {{ currentItem.excludeFrom || '...' }}&nbsp;—&nbsp;{{ currentItem.excludeTo || '...' }}
              </span>
            </h5>
            <div class="sms-table">
              <div class="sms-item client-item header-row">
                <div class="sms-val" style="width: 160px;">Дата заказа</div>
                <div class="sms-val">Клиент</div>
                <div class="sms-val">Телефон</div>
                <div class="sms-val">
                  Статус
                  <select style="width: 130px;font-size: 13px;" @change="filterStatus($event)">
                    <option :value="null">---</option>
                    <option v-for="(segmentClientStatus, segmentClientStatusId) in segmentClientStatuses"
                            :value="segmentClientStatusId">
                      {{ segmentClientStatus }}
                    </option>
                  </select>
                </div>
                <div class="sms-val">СМС Звонок</div>
              </div>
              <div v-for="client in clients"
                   v-if="currentFilterStatus === null || parseInt(currentFilterStatus) === parseInt(client.segmentClientStatus)"
                   class="sms-item client-item">
                <div class="sms-val">{{ client.date }}</div>
                <div class="sms-val">
                  <i class="icon-fa icon-fa-user"></i> {{ client.clientName }}
                  <div style="font-size: 14px;color: grey;">
                    {{ client.city }}<span v-if="client.projectLabel" class="ml-1">({{ client.projectLabel }})</span>
                  </div>
                </div>
                <div class="sms-val"><i class="icon-fa icon-fa-phone"></i> {{ client.phone }}</div>
                <div class="sms-val">
                  <div style="margin-bottom: 10px;font-size: 14px;color: #636363;font-weight: bold;">
                    <span v-if="currentSmsClient !== client.id">{{ client.segmentClientStatusLabel }}</span>
                    <select :id="'segmentClientStatus' + client.id" v-else>
                      <option v-for="(segmentClientStatus, segmentClientStatusId) in segmentClientStatuses"
                              :selected="parseInt(segmentClientStatusId) === parseInt(client.segmentClientStatus)"
                              :value="segmentClientStatusId">
                        {{ segmentClientStatus }}
                      </option>
                    </select>
                  </div>
                  <textarea :id="'segmentClientComment' + client.id"
                            v-if="client.segmentClientComment || currentSmsClient === client.id"
                            class="form-control mb-1"
                            :disabled="currentSmsClient !== client.id"
                            :value="client.segmentClientComment ? client.segmentClientComment : null"
                            placeholder="Добавить примечание"></textarea>
                  <button v-if="currentSmsClient !== client.id" @click="editSmsClient(client)"
                          style="font-size: 13px;"
                          class="btn btn-sm btn-default">Изменить</button>
                  <button v-if="currentSmsClient === client.id" @click="editSmsClient(client)"
                          style="font-size: 13px;"
                          class="btn btn-sm btn-success">OK</button>
                </div>
                <div class="sms-val">
                  <button class="btn btn-sm"
                          @click="sendSms(currentItem, true, {
                            resend: client.smsId ? client : null,
                            orderDetail: !client.smsId ? client : null,
                            handleId: client.smsId ? client.smsId : client.id,
                          })"
                          :disabled="loadingSend || (client.status && client.status !== '0')"
                          :class="{
                            'btn-outline-default': client.status === null,
                            'btn-success': client.status && client.status !== '0',
                            'btn-danger': client.status === '0',
                          }"
                          title="Отправить смс"
                          type="button"><i class="icon-fa icon-fa-send"></i></button>
                  <MakeCall v-if="client.phone && client.phone.length"
                            :phone="client.phone" :order="client.order" class="d-inline-block">
                    <slot name="btn">
                      <button :disabled="loadingSend"
                              class="btn btn-sm btn-outline-default ml-1"
                              title="Звонок"
                              type="button"><i class="icon-fa icon-fa-phone"></i></button>
                    </slot>
                  </MakeCall>
                  <button class="btn btn-sm btn-outline-default ml-1"
                          @click="makeOrder(client)"
                          :disabled="loadingSend"
                          title="Создать заказ"
                          type="button"><i class="icon-fa icon-fa-medkit"></i></button>
                </div>
              </div>
            </div>
          </div>
        </sweet-modal>
        <div v-if="!loading && !items.length">
          Нет активных сегментов
        </div>
        <div :id="'segmentItem' + item.id" class="segment-item d-flex" v-for="item in items" :key="item.id">
          <div>
            <h6>{{ item.title }} <span style="font-weight: normal">[ID: {{ item.id }}]</span></h6>
            <div class="info-items">
              <div class="info-item date-items">
                <span v-if="item.includeFrom || item.includeTo" class="include-label">
                  <i class="icon-fa icon-fa-plus"></i>
                  {{ item.includeFrom || '...' }}&nbsp;—&nbsp;{{ item.includeTo || '...' }}
                </span><br>
                <span v-if="item.excludeFrom || item.excludeTo" class="exclude-label">
                  <i class="icon-fa icon-fa-minus"></i>
                  {{ item.excludeFrom || '...' }}&nbsp;—&nbsp;{{ item.excludeTo || '...' }}
                </span>
              </div>
              <div class="info-item">
                <b>Клиентов:</b>
                <span @click="showClients(item)" class="clients-info"
                      :style="'opacity:' + (loadingClients === item.id ? '50' : '100') + '%'">{{ item.canSendCount }} ({{ item.clientsCount }})</span>
                <div class="progress">
                  <div class="progress-bar" role="progressbar"
                       :style="'width:' + (item.sentSmsCount * 100 / item.clientsCount) + '%'"></div>
                </div>
              </div>
              <div class="info-item">
                <b>Доступно:</b> {{ item.inStore }} уп.
              </div>
              <div class="info-item" v-if="smsSpoiler.includes(item.id)">
                <b>Отправлено:</b> <span @click="showSms(item)" class="clients-info"
                      :style="'opacity:' + (loadingSms === item.id ? '50' : '100') + '%'">{{ item.sentSmsCount }} смс</span>

              </div>
              <div class="info-item" v-else>
                <span @click="showSmsSpoiler(item.id)" class="clients-info">СМС</span>
              </div>
            </div>
          </div>
          <div class="send-wrap">
            <b v-if="smsSpoiler.includes(item.id)">Отправить</b>
            <div class="d-flex align-items-center">
              <div class="input-group mt-1 flex-nowrap" v-if="smsSpoiler.includes(item.id)">
                <input :id="'segmentSmsCount' + item.id" type="number" class="form-control input-sm" :value="item.toSendCount">
                <div class="input-group-append">
                  <button @click="sendSms(item, true)" :disabled="loadingSend" class="btn btn-sm btn-outline-success"
                          type="button" title="Отправить">
                    <i class="icon-fa icon-fa-send"></i>
                  </button>
                  <!--<button @click="sendSms(item, true)" :disabled="loadingSend" class="btn btn-sm btn-outline-secondary"
                          type="button" title="В очередь">
                    <i class="icon-fa icon-fa-clock-o"></i>
                  </button>-->
                </div>
              </div>
              <div class="input-group ml-2">
                <button @click="mixinGoToRouter('segmentSMS', {id: item.id})" class="btn btn-sm btn-outline-primary mr-1" type="button">
                  <i class="icon-fa icon-fa-pencil"></i>
                </button>
                <button @click="deleteItem(item)" class="btn btn-sm btn-outline-danger">
                  <i class="icon-fa icon-fa-trash"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="send-progress" :style="{width: loadingSendProgress + '%'}" v-if="loadingSend === item.id"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import api from "@/api";
  import ordersList from "@/components/orders/ordersList";
  import VueLadda from "vue-ladda/src/vue-ladda.vue";
  import { SweetModal } from 'sweet-modal-vue';
  import MakeCall from '@/components/orders/telephony/MakeCall';

  export default {
    components: {
      ordersList,
      VueLadda,
      SweetModal,
      MakeCall,
    },
    data () {
      return {
        items: {},
        smsItems: {},
        clients: {},
        segmentClientStatuses: {},
        currentItem: null,
        loading: true,
        loadingAdd: false,
        loadingEdit: false,
        loadingSend: false,
        loadingSms: false,
        loadingClients: false,
        loadingSendProgress: 0,
        currentSmsClient: null,
        currentFilterStatus: null,
        smsSpoiler: [],
      }
    },
    methods: {
      addItem() {
        this.loadingAdd = true;
        this.mixinGoToRouter('segmentSMS');
      },
      async getItems() {
        let {data} = await api.index('/sms/segments');
        this.items = data.items;
        this.loading = false;
      },
      async makeCall(client) {
        alert(client.phone);
      },
      async sendSms(item, direct, options = {}) {
        let resend = options.resend !== undefined && options.resend ? options.resend : null;
        let orderDetail = options.orderDetail !== undefined && options.orderDetail ? options.orderDetail : null;
        let handleId = options.handleId !== undefined && options.handleId ? options.handleId : null;
        let qty = resend || orderDetail ? 1 : parseInt(document.getElementById('segmentSmsCount' + item.id).value);
        let confirmLabel = direct ? 'Отправить' : 'Добавить в очередь';
        if (qty > 10 && !confirm(confirmLabel + ' ' + qty + ' смс с текстом:\n' + item.template)) {
          return false;
        }

        this.loadingSend = item.id;
        item.toSendCount = qty;
        this.loadingSendProgress = 0;
        let step = 100 / qty;
        step = step < 5 ? 5 : step;
        let progress = setInterval(() => {
          this.loadingSendProgress = this.loadingSendProgress + step;
          if (this.loadingSendProgress >= 99) {
            clearInterval(progress);
          }
        }, 1000);

        let sendData = {segment_id: parseInt(item.id), qty: qty};
        if (resend) {
          sendData['resend_id'] = parseInt(handleId ? handleId : resend.id);
        }
        if (orderDetail) {
          sendData['order_detail_id'] = parseInt(handleId ? handleId : orderDetail.id)
        }
        let sendUrl = resend ? '/sms/segment/reSend' : '/sms/segment/send';
        let {data} = await api.post(sendUrl, sendData);

        if (data.success) {
          toastr['success'](data.message);
        }

        if (data.error) {
          toastr['error'](data.error || 'Ошибка!');
        }

        if (data.item) {
          item.canSendCount = data.item.canSendCount;
          item.clientsCount = data.item.clientsCount;
          item.sentSmsCount = data.item.sentSmsCount;
          item.inStore = data.item.inStore;
        }

        if (data.sms) {
          let smsStatus = data.sms ? data.sms.status.toString() : null;
          let smsSystemInfo = data.sms ? data.sms.system_info : null;
          if (resend) {
            resend.status = smsStatus !== null ? smsStatus : resend.status;
            resend.system_info = smsSystemInfo !== null ? smsSystemInfo : resend.system_info;
          }
          if (orderDetail) {
            orderDetail.status = smsStatus !== null ? smsStatus : orderDetail.status;
            orderDetail.smsId = data.sms ? data.sms.id : null;
          }
        }

        this.loadingSendProgress = 100;
        setTimeout(() => {
          this.loadingSend = false;
        }, 1000);
        clearInterval(progress);
      },
      async showClients(item) {
        this.loadingClients = item.id;
        let {data} = await api.index('/sms/segment/clients?segment_id=' + item.id);
        this.currentItem = item;
        this.clients = data.clients;
        this.segmentClientStatuses = data.segmentClientStatuses;
        this.loading = false;
        this.loadingClients = false;
        this.$refs.showClientsModal.open();
      },
      async showSms(item) {
        this.loadingSms = item.id;
        let {data} = await api.index('/sms/segment/smsItems?segment_id=' + item.id);
        this.currentItem = item;
        this.smsItems = data.items;
        this.loading = false;
        this.loadingSms = false;
        this.$refs.showSmsModal.open();
      },
      async deleteItem(item) {
        if (!confirm('Удаление сегмента ' + item.title)) {
          return false;
        }

        let {data} = await api.post('/sms/segment/delete', {
          segment_id: parseInt(item.id)
        });

        if (data.success) {
          toastr['warning']('Успешно удалено!');
          document.getElementById("segmentItem" + item.id).remove();
        } else {
          toastr['error'](data.error || 'Ошибка!');
        }
      },
      async editSmsClient(item) {
        if (this.currentSmsClient === item.id) {
          let comment = document.getElementById('segmentClientComment' + item.id).value
          let statusSelect = document.getElementById('segmentClientStatus' + item.id)
          let statusLabel = statusSelect.options[statusSelect.selectedIndex].text;
          let status = statusSelect.value;

          let {data} = await api.post('/sms/segment/editClient', {
            id: parseInt(item.segmentClientId),
            segment_id: parseInt(this.currentItem.id),
            order_id: parseInt(item.orderId),
            comment: comment.length ? comment : null,
            manage_status: status ? status : 0,
          });

          if (data.success) {
            toastr['success']('Успешно обновлено!');
            item.segmentClientComment = comment;
            item.segmentClientStatus = status;
            item.segmentClientStatusLabel = statusLabel;
            this.currentSmsClient = null;
          } else {
            toastr['error']('Ошибка!');
          }
        } else {
          this.currentSmsClient = item.id;
        }
      },
      filterStatus(event) {
        let val = event.target.value;
        val = val === '' ? null : val;
        this.currentFilterStatus = val;
      },
      showSmsSpoiler(id) {
        this.smsSpoiler.push(id);
      },
      makeOrder(client) {
        const data = {
          client: client.client_id,
          phoneNum: client.phone,
          extra_data: {

          },
        };

        this.mixinGoToRouter('newOrder', data);
      },
    },
    mounted() {
      this.getItems();
    },
  };
</script>

<style lang="scss" scoped>
  .segment-item {
    position: relative;
    background: #80808014;
    border-radius: 3px;
    padding: 29px 26px;
    margin-bottom: 16px;
    border: 1px solid #8080801f;
    box-shadow: 1px 2px 4px 0 rgba(0,0,0,0.2);
    justify-content: space-between;
    align-items: center;

    &:last-child {
      margin-bottom: 16px;
    }

    h6 {
      color: #343a52;
      font-weight: bold;
      margin-bottom: 12px;
    }

    .info-items {
      display: flex;
      align-items: center;
      font-size: 14px;

      .info-item.date-items {
        width: 175px;
        max-width: 100%;
      }

      .info-item:not(:last-child) {
        margin-right: 32px;
      }

      .progress {
        margin-top: 3px;
        height: 10px;
      }
    }

    .send-wrap {
      font-size: 14px;

      input {
        width: 82px;
      }
    }

    .send-progress {
      position: absolute;
      bottom: 0;
      left: 0;
      height: 8px;
      background: #4fc47f;
      max-width: 100%;
      transition: 0.2s ease;

      &.error {
        background: red;
      }
    }

    .clients-info {
      color: #007dcc;
      text-decoration: underline;
      cursor: pointer
    }
  }

  .sms-table {
    display: table;
    border-collapse: collapse;
    width: 100%;
  }

  .sms-item {
    /*display: flex;*/
    display: table-row;
    align-items: center;
    justify-content: space-between;
    background: #e7ffe7;
    color: #094409;
    border-bottom: solid #fff 5px;

    .icon-fa {
      color: #9d9d9d;
    }

    .btn-success, .btn-danger {
      .icon-fa {
        color: #fff;
        opacity: 0.8;
      }
    }

    &.sms-error {
      background: #ffb9b9;
      color: #5f0909;

      .btn-success {
        box-shadow: 0 1px 1px 1px rgba(255,255,255,0.3);

        .icon-fa {
          color: #b8ffd5;
        }
      }
    }

    .sms-val {
      display: table-cell;
      vertical-align: middle;
      padding: 16px 18px 16px 10px;

      &:first-child {
        padding-left: 22px !important;
      }

      &.sms-body {
        width: 500px;
        font-size: 13px;
      }

      .send-error {
        line-height: 100%;
        font-size: 80%;
        margin: 7px 0;
      }

      textarea {
        font-size: 14px;
      }
    }

    &.client-item:not(.header-row) {
      &:nth-child(odd) {
        background: #f1f1f1;
      }

      &:nth-child(even) {
        background: #e4eaedb0;
      }

      &:hover {
        background: #ecedd066;
      }
    }
  }

  .header-row {
    font-weight: bold;
    background: #343a52eb;
    color: #fff;

    .sms-val {
      background-color: #343a52;
      position: sticky;
      top: 0;
      z-index: 2;
    }
  }

  .include-label {
    color: #209002;
    font-size: 14px;
  }

  .exclude-label {
    color: #b10606;
    font-size: 14px;
  }
</style>
